import { EffectCallback, useEffect } from 'react';

const useEffectOnce = (callback: EffectCallback) => {
  useEffect(callback, []);
};

export default useEffectOnce;
